module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4r8n7r-fb2c7a131e897990ca6670f15dedc70f.svg";